/** Where the Knowledge Base lives: the landing (choices and the Diagnostics view). */
export const KNOWLEDGE_BASE_PATH = "/faults-diagnostics/knowledge";

/** Extracting diagnostics from a manual (extraction plan step 04). */
export const KNOWLEDGE_EXTRACT_PATH = `${KNOWLEDGE_BASE_PATH}/extract`;

/** Your unfinished extractions. */
export const KNOWLEDGE_CONTINUE_PATH = `${KNOWLEDGE_BASE_PATH}/continue`;

/** One extraction's workspace. */
export const extractionPath = (sessionId) => `${KNOWLEDGE_EXTRACT_PATH}/${sessionId}`;

/**
 * One extraction's workspace with an asset type in view: its confirmed diagnostics from the manual are listed with
 * your entries (updating a whole asset type). Without an asset type, the plain workspace.
 */
export const assetTypeUpdatePath = (sessionId, assetTypeId) =>
  (assetTypeId ? `${extractionPath(sessionId)}?assetType=${encodeURIComponent(assetTypeId)}` : extractionPath(sessionId));

/** Confirmed diagnostics from a manual, without creating a private extraction. */
export const manualExtractionPath = (fileId) => `${KNOWLEDGE_EXTRACT_PATH}/manual/${encodeURIComponent(fileId)}`;

/** The breadcrumb for a workspace: the manual's title after EXTRACT, rather than the session's id. */
export const extractionTrail = (title) => [
  { label: "FAULTS-DIAGNOSTICS", to: "/faults-diagnostics" },
  { label: "KNOWLEDGE BASE", to: KNOWLEDGE_BASE_PATH },
  { label: "EXTRACT", to: KNOWLEDGE_EXTRACT_PATH },
  { label: String(title || "MANUAL").toUpperCase() },
];

